<template>
    <div class="pay-commponet">
        <el-dialog
        :visible.sync="showComponent"
        :title="showTips['html']"
        center>
        <div class="pay-list">
            <!-- <div v-if="showTips['show']">{{showTips['html']}}</div> -->
            <div v-for="(item,index) in payArr" 
                @click="change(item,index)"
                :class="[{'active':item.active},'item',{'isEngCss':isChinese}]"
                :key="index">{{item.title}}</div>
        </div>
      </el-dialog>
     <AlertComponent ref="payOver" 
                    @getCloseType="getCloseType"></AlertComponent>
    <AlertErweimaComponent ref="erweima"></AlertErweimaComponent>
    </div>
</template>
<style scoped>
    >>>.el-dialog{
        max-width: 360px;
        min-width: 330px;
    }
    .pay-list .item{
        border: 1px solid #979797;
        border-radius: 8px;  
        border-radius: 8px;
        height:35px;
        line-height: 35px;
        text-align: center;
        cursor: pointer;
        margin-bottom: 20px;
    }
    .pay-list .item.isEngCss{
       font-size:12px;
    }

    .pay-list .item:last-child{
        margin-bottom: 0;
    }
    .pay-list .item.active{
        color :#fff;
        background: #5EBB8D; 
        border-color:#5EBB8D;
    }
</style>
<script>
  import { setInterval, clearInterval, setTimeout } from 'timers';
  import { payDoc} from '@/api/user'
  import { whatLang } from '@/utils/index'
  import { getBacking,handleOpen,getFree} from '@/api/doc'
  import { isPhone} from '@/api/public'
  import AlertComponent  from '../components/alertComponent.vue';
  import AlertErweimaComponent from '../components/AlertErweimaComponent.vue'
  export default {
    name: "PayVipComponent",
    components:{AlertComponent,AlertErweimaComponent},
    data() {
      return {
            showComponent:false,
            id:'',
            userId:'',
            item:'',
            showTips:{
                'html':'',
                'show':false,
            },
            payArr: [],
            isChinese: whatLang() !='zh'
      };
    },
    methods: {
        info(){
            this.payArr.map(v=>v.active = false);
            this.payArr[1]['active'] = true;
        },
        show(obj){
            this.payArr = [
                {
                    title:this.$t('vipComponent.pay.free'),
                    type:3,
                    active:false,
                    disbase:false
                },
                {
                    title:this.$t('vipComponent.pay.friend'),
                    type:0,
                    active:false,
                    disbase:false
                },
                {
                    title:this.$t('vipComponent.pay.money'),
                    type:1,
                    active:false,
                    disbase:false,
                },
                {
                    title:this.$t('vipComponent.pay.vip'),
                    type:2,
                    active:false,
                    disbase:false,
                }
            ];

            if(obj.data.is_allow === true &&  !obj.data['pay_detail']){
                 handleOpen(obj.item);
            }else{
                this.id = obj.item.doc_id;
                this.userId = obj.userId;
                this.item = obj.item;
                const pay_detail = obj['data']['pay_detail'] || {};
                const pay_type = obj['data']['pay_type'] || {};
                if(pay_type === - 4 ){
                    console.log('vip  次数用完了');
                    this.payArr = this.payArr.slice(0,3);
                    const price = pay_detail['price'] || ''; 
                    if(price){
                        const discount = parseInt(pay_detail['discount']);
                        let payTitle2 = '';
                        if(this.isChinese){
                            payTitle2 = `${this.$t('vipComponent.pay.money1')}${price} ${this.$t('vipComponent.pay.money5')} ( ${this.$t('vipComponent.pay.money3')}  ${(10 - discount)*10}% ${this.$t('vipComponent.pay.money4')} ) ${this.$t('vipComponent.pay.money2')}`;
                        }else{
                            payTitle2 = `${this.$t('vipComponent.pay.money1')}${price} ${this.$t('vipComponent.pay.money5')}( ${this.$t('vipComponent.pay.money3')}  ${discount} ${this.$t('vipComponent.pay.money4')} ) ${this.$t('vipComponent.pay.money2')}`;
                        }
                        this.payArr[2]['title'] = payTitle2;
                    }
                    const free_count = pay_detail['free_download_times_remain'] || 0 ;
                    this.getFreeCount(free_count);
                    this.showTips['html'] = this.$t('vipComponent.tips');
                    this.showTips['show'] = true;
                }else{
                    this.showTips['html'] = '';
                    this.showTips['show'] = false;
                    const price = pay_detail['price']|| ''; 
                    if(price){
                            // this.payArr = this.payArr.slice(2,1);
                        this.payArr[2]['title'] = `${this.$t('vipComponent.pay.money1')}${price}${this.$t('vipComponent.pay.money5')}${this.$t('vipComponent.pay.money2')}`;
                    }
                    const free_count = pay_detail['free_download_times_remain'] || 0 ;
                    this.getFreeCount(free_count);
                }
                const people = pay_detail['backing']['required_num'] - pay_detail['backing']['backer_num'];
                const _people = people > 0 ? people : 0 ;
                if(_people>0){
                    this.payArr[1]['title'] = `${this.$t('vipComponent.pay.friend1')}${_people}${this.$t('vipComponent.pay.friend2')}`;
                }
                if(isPhone()){
                    this.payArr.splice(2,1);
                }
                console.log(this.payArr);
                this.info();
                this.showComponent = true; 
            }
        },
        hide(){
            this.showComponent = false;
        },
        getFreeCount:function(count){
            if(count>0){
                this.payArr[0]['title'] = `${this.$t('vipComponent.pay.free1')} ${count} ${this.$t('vipComponent.pay.free2')}`;
            }else{
                this.payArr[0]['title'] = `${this.$t('vipComponent.pay.freeOver')}`;
                this.payArr[0]['disbase'] =true;
            }
        },
        change(item,index,disbase) {
            if(item.disbase && item.type ==3){
                this.showError(this.$t('vipComponent.over'),'error');   
                return 
            }
            this.payArr.map(v=>v.active = false);
            this.payArr[index]['active'] = true;
            this.refPayItem({
                id:this.id,
                type:item['type'],
                item:this.item
            });
        },
        refPayItem:function(obj){
            if(obj.type == 0 ){
                getBacking(this.userId,obj.id).then(res=>{
                    if(res.rc == 0 ){
                        if(res.status == 2){
                            handleOpen(this.item);
                        }else{
                            if((res.required_num - res.backer_num) > 0 ){
                                const url = (window.location.host === 'localhost:8081'? 'http://localhost:8080':'https://www.caiyunapp.com' ) + '/pay_down_share/?id='+obj.id;
                                if(isPhone()){
                                    window.location.href = url;
                                }else{
                                    this.$refs.erweima.show({
                                        url:url
                                    })
                                }
                            }
                        }
                    }else  if(res.rc == -1){
                        this.showError(this.$t('vipComponent.helpError'),'error');
                    }
                }).catch(err=>{
                   this.showError(this.$t('vipComponent.helpError'),'error');
                });
            }else if(obj.type == 1){
                window.open("about:blank","alipay")   //打开新窗口，地址为"about:blank"，窗口名为"alipay"
                payDoc(obj.id).then(res =>{
                    console.log(res);
                    if(res.rc == 0){
                        //弹出弹窗
                        this.payOver(obj.item);
                        window.open(null,'alipay').location.href = res.alipay.notify_url;
                    }else{
                        this.showError(this.$t('vipComponent.orderError'),'error');
                    }
                }).catch(err=>{
                    this.showError(this.$t('vipComponent.orderError'),'error');
                })
            }else if(obj.type == 2 ){
                this.$router.push({ path: '/mine/vip'});
            }else if(obj.type == 3){
                console.log('免费加载接口');
                this.getFree(obj.id);
            }
        },
        payOver:function(obj){
            this.$refs.payOver.show({
                item:obj
            })
        },
        getCloseType:function(obj){
            if(obj.type == 1){
                handleOpen(obj.item);
                this.hide();
            }
        },
        showError:function(des,type,cb){
            const obj = {};
            obj['message'] = des;
            obj['closable'] = false;
            obj['duration']=3000;
            if(type){
                obj['type'] = type;
            }
            this.$message(obj);
        },
        getFree:function(id){
            getFree(id,this.userId).then(res=>{
                console.log(res);
                if(res.rc == 0){
                    this.getFreeCount(res.free_download_times_remain);
                    this.$message({
                        'message':this.$t('vipComponent.userFree'),
                        'type':'success',
                        'showClose': true,
                        'duration':0,
                    });
                    this.hide();
                    handleOpen(this.item);
                }
            }).catch(err=>{
                console.log(err);
            })
        },  
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/PayVipComponent.vue